import { closeIcon, eyLogo } from "assets/media";
import { correctIcon } from "assets/media/icons/custom/correctIcon";
import { xmLogoCondensed, xmLogo } from "assets/media/images/xm-logo1";

export const ImageCollection = {
  EY_LOGO: eyLogo,
  XM_LOGO_SMALL: eyLogo,
  XM_LOGO_BIG: eyLogo
};

export const IconCollection = {
  IC_CHECK: correctIcon,
  IC_CLOSE: closeIcon
};
